import { apiFetch } from "../../lib/api";
import type { Customer, CustomerBulkImportResult, CustomerInput } from "./customers.types";

export async function createCustomer(input: CustomerInput): Promise<Customer> {
  const response = await apiFetch("/customers", {
    method: "POST",
    body: JSON.stringify(input),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: "Erreur lors de l'ajout du client." }));
    throw new Error(error.error || "Erreur lors de l'ajout du client.");
  }

  return response.json();
}

export async function addCustomersBulk(inputs: CustomerInput[]): Promise<CustomerBulkImportResult> {
  const response = await apiFetch("/customers/bulk", {
    method: "POST",
    body: JSON.stringify(inputs),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: "Erreur lors de l'import des clients." }));
    throw new Error(error.error || "Erreur lors de l'import des clients.");
  }

  return response.json();
}